import React from "react";

import { Line } from "react-chartjs-2";

// import "chartjs-plugin-datalabels";
import { API_CONSTANTS } from "../../../../utils/constantInformation";

const calculateYIntercept = (yMean, slope, xMean) => {
  return yMean - slope * xMean;
};
const calculateSlope = (x, y, xMean, yMean) => {
  const n = x.length;
  let numerator = 0;
  let denominator = 0;

  for (let i = 0; i < n; i++) {
    numerator += (x[i] - xMean) * (y[i] - yMean);
    denominator += Math.pow(x[i] - xMean, 2);
  }

  const slope = numerator / denominator;
  return slope;
};

const calculateMean = (data) => {
  let sum = 0;
  for (let i = 0; i < data.length - 1; i++) {
    sum += data[i];
  }
  const mean = sum / (data.length - 1);
  return mean;
};

const daysSinceStartDate = (dateStr, startDateStr) => {
  // Convert the input strings to Date objects
  const date = new Date(dateStr);
  const startDate = new Date(startDateStr);

  // Calculate the difference in time between the two dates
  const timeDiff = date.getTime() - startDate.getTime();

  // Convert the difference in time to days
  const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));

  return daysDiff;
};

const calculateY = (m, b, date, startDate) => {
  let x = daysSinceStartDate(date, startDate);
  return m * x + b;
};

function PlayerChart(props) {
  const [graph_data, setGraphData] = React.useState([]);
  const [axis_tooltip, setToolTips] = React.useState([]);
  const axes = [
    {
      primary: true,
      type: "time",
      time: {
        unit: "month",
      },
      position: "bottom",
    },
    {
      type: "linear",
      position: "left",
    },
  ];
  React.useEffect(async () => {
    let actual_stats = [];
    let projected_stats = [];
    let floor_stats = [];
    let ceil_stats = [];
    let axis_tooltip = [];
    let trendStats = [];

    var player_stats = props.player_stats;
    const size = player_stats.length

    if(size>10){
      player_stats = player_stats.slice(size-10 , size)
    }

    let actual_performance = player_stats.map(
      (item) => item["Dream11ActualFantasyPoints"]
    );
    let startingDate = player_stats[0]["Date"];
    let daysSinceStartDateList = player_stats.map((item) =>
      daysSinceStartDate(item["Date"], startingDate)
    );
    console.log("Starting Date: ", typeof startingDate);
    console.log("Actual Performance: ", actual_performance);

    let xMean = calculateMean(actual_performance);
    let yMean = calculateMean(daysSinceStartDateList);

    console.log("xMean: ", xMean, "yMean: ", yMean);

    let slope = calculateSlope(
      daysSinceStartDateList,
      actual_performance,
      xMean,
      yMean
    );

    console.log("Slope: ", slope);
    let yIntercept = calculateYIntercept(yMean, slope, xMean);
    console.log("yIntercept: ", yIntercept);

    player_stats.forEach(function(item, i) {
      if (item["Dream11ActualFantasyPoints"] == API_CONSTANTS.NUMERIC_CONSTANT)
        player_stats[i]["Dream11ActualFantasyPoints"] =
          API_CONSTANTS.NULL_CONSTANT;
      if (
        item["Dream11ProjectedFantasyPoints"] == API_CONSTANTS.NUMERIC_CONSTANT
      )
        player_stats[i]["Dream11ProjectedFantasyPoints"] =
          API_CONSTANTS.NULL_CONSTANT;
      if (
        item["Dream11ProjectedFloorFantasyPoints"] ==
        API_CONSTANTS.NUMERIC_CONSTANT
      )
        player_stats[i]["Dream11ProjectedFloorFantasyPoints"] =
          API_CONSTANTS.NULL_CONSTANT;
      if (
        item["Dream11ProjectedCeilFantasyPoints"] ==
        API_CONSTANTS.NUMERIC_CONSTANT
      )
        player_stats[i]["Dream11ProjectedCeilFantasyPoints"] =
          API_CONSTANTS.NULL_CONSTANT;
    });

    for (var i = 0; i < player_stats.length - 1; i++) {
      trendStats.push({
        x: new Date(player_stats[i]["Date"]),
        y: calculateY(
          slope,
          yIntercept,
          player_stats[i]["Date"],
          startingDate
        ),
      });
    }

    console.log("trendStats: ", trendStats);

    for (var i = 0; i < player_stats.length; i++) {
      actual_stats.push({
        x: new Date(player_stats[i]["Date"]),
        y: player_stats[i]["Dream11ActualFantasyPoints"],
      });
      projected_stats.push({
        x: new Date(player_stats[i]["Date"]),
        y: player_stats[i]["Dream11ProjectedFantasyPoints"],
      });
      floor_stats.push({
        x: new Date(player_stats[i]["Date"]),
        y: player_stats[i]["Dream11ProjectedFloorFantasyPoints"],
      });
      ceil_stats.push({
        x: new Date(player_stats[i]["Date"]),
        y: player_stats[i]["Dream11ProjectedCeilFantasyPoints"],
      });

      const date = new Date(player_stats[i]["Date"]);

      //@TODO: Replace the below code when backend API contains the opponent name.
      const oppenent = player_stats[i]["GameID"]
        .replace(/[0-9]*/g, "")
        .replace(player_stats[i]["Team"], "");

      axis_tooltip.push([
        date.getDate() + "/" + parseInt(date.getMonth() + 1),
        "vs",
        oppenent,
      ]);
    }

    const graph_data = [
      {
        label: "Actual FP",
        // radius: 4,
        hoverRadius: 7,
        pointStyle: "circle",
        pointRadius: 6,

        hoverBorderWidth: 2,
        fill: false,
        data: actual_stats,
        borderColor: "lightblue",
        lineTension: 0,
      },
      {
        label: "Projected FP",
        // radius: 4,
        hoverRadius: 7,
        pointStyle: "circle",
        pointRadius: 6,
        hoverBorderWidth: 2,
        fill: false,
        data: projected_stats,
        borderColor: "orange",
        lineTension: 0,
      },
      {
        label: "Floor",
        // radius: 4,
        hoverRadius: 7,
        pointStyle: "triangle",
        pointRadius: 6,
        hoverBorderWidth: 2,
        fill: false,
        data: floor_stats,
        borderColor: "#FF355E",
        borderDash: [10, 5],
        borderWidth: 1,
        lineTension: 0,
      },
      {
        label: "Ceil",
        // radius: 4,
        hoverRadius: 7,
        pointStyle: "star",
        pointRadius: 6,
        hoverBorderWidth: 2,
        fill: false,
        data: ceil_stats,
        borderColor: "#66ff00",
        borderDash: [10, 5],
        borderWidth: 1,
        lineTension: 0,
      },
      // {
      //   label: "Scoring Trend",
      //   // radius: 4,
      //   hoverRadius: 7,
      //   pointStyle: "star",
      //   pointRadius: 6,
      //   hoverBorderWidth: 2,
      //   fill: false,
      //   data: trendStats,
      //   borderColor: "#66ff00",
      //   borderDash: [10, 5],
      //   borderWidth: 1,
      //   lineTension: 0,
      // },
    ];

    setGraphData(graph_data);
    setToolTips(axis_tooltip);
  }, []);

  return (
    <div>
      <div className="details-graph-div container" style={{ height: "50vh" }}>
        <Line
          data={{
            datasets: graph_data,
          }}
          options={{
            maintainAspectRatio: false,
            plugins: {},
            // plugins: {
            //   datalabels: {
            //     formatter: function (value, context) {
            //       return value["y"] + "\n\n";
            //     },
            //     color: "black",
            //   },
            // },
            legend: {
              display: true,
              labels: {
                fontColor: "black",
                usePointStyle: true,
              },
              position: "bottom",
              align: "center",
            },
            tooltips: {
              enabled: true,
              mode: "index",
            },
            scales: {
              xAxes: [
                {
                  type: "category",
                  labels: axis_tooltip,
                  ticks: {
                    fontColor: "black",
                  },
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    // zeroLineColor: "#ffcc33",
                    zeroLineColor: "#28282B",
                    // borderDash: [10, 15],
                    // color: "gray",
                  },
                  ticks: {
                    fontColor: "black",
                    min: -25,
                    stepSize: 25,
                  },
                },
              ],
            },
          }}
        />
      </div>
    </div>
  );
}

export default PlayerChart;
